import { Check } from "lucide-react";
import type { LucideIcon } from "lucide-react";

interface ChecklistProps {
  items: string[];
  icon?: LucideIcon;
  columns?: 1 | 2;
}

const Checklist = ({ items, icon: Icon = Check, columns = 1 }: ChecklistProps) => {
  const colClass = columns === 2 ? "grid grid-cols-1 md:grid-cols-2 gap-3" : "space-y-3";

  return (
    <ul className={colClass} role="list">
      {items.map((item, i) => (
        <li key={i} className="flex items-start gap-3">
          <Icon className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" strokeWidth={2} aria-hidden="true" />
          <span className="text-muted-foreground text-sm md:text-base leading-relaxed">{item}</span>
        </li>
      ))}
    </ul>
  );
};

export default Checklist;
